module.exports = __webpack_public_path__ + "img/category-brand.b8d2a5d1.png";